export const BAZA_PASSWORD_MIN_LENGTH = 8;
export const BAZA_PASSWORD_MAX_LENGTH = 32;
export const BAZA_PASSWORD_MIN_PHRASE_LENGTH = 8;
export const BAZA_PASSWORD_MIN_OPTIONAL_TESTS_TO_PASS = 4;

export const BAZA_PASSWORD_RESOURCES_UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const BAZA_PASSWORD_RESOURCES_LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
export const BAZA_PASSWORD_RESOURCES_DIGITS = '0123456789';
export const BAZA_PASSWORD_RESOURCES_SPECIAL = '!?@#$%^&*()_+=-[]{}\\|/.<>,~`\'"';
